module.exports = __webpack_public_path__ + "static/media/Kreon-01.766997a5.svg";